import { useQuery } from './utils';
import { WidgetItemQuery } from './queries';

import type { QueryResult } from './utils';
import type { WidgetItemType } from './schemas';

export type UseWidgetQueryArgs = {
  id: string;
  apiToken: string;
  apiVersion?: 'draft' | 'published';
  skipQuery?: boolean;
};

export const useWidgetQuery = ({
  id,
  apiToken,
  apiVersion = 'published',
  skipQuery,
}: UseWidgetQueryArgs): QueryResult<{ WidgetItem?: WidgetItemType }> => {
  return useQuery<{ WidgetItem?: WidgetItemType }>(
    WidgetItemQuery,
    {
      id,
    },
    {
      token: apiToken,
      version: apiVersion,
    },
    skipQuery,
  );
};
